<!-- Sync Client Modal -->
<p-dialog
  [visible]="visible()"
  (onHide)="closeDialog(false)"
  [resizable]="false"
  appendTo="body"
  [modal]="true"
  [breakpoints]="{ '767px': '100vw' }"
  [style]="{ width: '500px' }"
  styleClass="no-header-modal"
  [attr.aria-label]="'sync-client-dialog'"
  [attr.data-testid]="'sync-client-dialog'"
>
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Content -->
    <div class="relative text-center p-4">
      <div
        class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer"
        (click)="closeDialog(false)"
        [attr.aria-label]="'close-dialog-button'"
        [attr.data-testid]="'close-dialog-button'"
      ></div>

      <i
        class="fa fa-sync text-6xl text-primary mb-3"
        [attr.data-testid]="'sync-client-icon'"
      ></i>

      <h4
        class="text-base md:text-lg my-3 font-bold"
        [attr.data-testid]="'sync-client-title'"
      >
        {{ 'CLIENT_PROFILE.SYNC_CLIENT.TITLE' | translate }}
      </h4>
      <p
        class="text-600 md:w-26rem mx-auto mb-0"
        [attr.data-testid]="'sync-client-message'"
      >
        {{ 'CLIENT_PROFILE.SYNC_CLIENT.MESSAGE' | translate }}
      </p>
    </div>
    <!-- Content -->

    <!-- Modal Footer -->
    <div
      class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300"
    >
      <button
        pButton
        pRipple
        type="button"
        [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate"
        class="p-button-secondary p-button-text text-sm"
        (click)="closeDialog(false)"
        [attr.aria-label]="'cancel-sync-button'"
        [attr.data-testid]="'cancel-sync-button'"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        [label]="'CLIENT_PROFILE.SYNC_CLIENT.SYNC_TO_SERVER' | translate"
        class="p-button-primary text-sm"
        [loading]="isSyncing"
        (click)="syncClientToServer()"
        [attr.aria-label]="'sync-to-server-button'"
        [attr.data-testid]="'sync-to-server-button'"
      ></button>
    </div>
    <!-- Modal Footer -->
  </ng-template>
</p-dialog>
<!-- Sync Client Modal -->
